import { useState } from "react";
import "../styles/main.css";

function Programs({ mode }) {
  const [popup, setPopup] = useState("");

  return (
    <div className={`programs ${mode === "school" ? "school-mode" : ""}`}>

      {/* SCHOOL */}
      {mode === "school" && (
        <section className="section">
          <h2>School Programs</h2>

          <div className="school-list-vertical">

            <div className="school-card">🎈 Play Group</div>
            <div className="school-card">🧸 Nursery</div>
            <div className="school-card">📚 Junior KG</div>
            <div className="school-card">🎓 Senior KG</div>

          </div>
        </section>
      )}

      {/*  COLLEGE  */}
      {mode === "college" && (
        <>
          <section className="section">
            <h2>Senior College Programs</h2>

            <p className="subtitle">
              Explore the wide range of subjects offered in our degree programs.
            </p>

            <div className="cards">

              {/* BA */}
              <div className="card">
                <h3>Bachelor of Arts (B.A)</h3>

                <ul>
                  <li onClick={() => setPopup("political")}>Political Science</li>
                  <li onClick={() => setPopup("psychology")}>Psychology</li>
                  <li onClick={() => setPopup("sociology")}>Sociology</li>
                </ul>

                <p><b>Intake:</b> 120</p>
                <p><b>Duration:</b> 3 Years</p>
              </div>

              {/* BCOM */}
              <div className="card">
                <h3>Bachelor of Commerce (B.Com)</h3>

                <ul>
                  <li onClick={() => setPopup("office")}>Office Management</li>
                  <li onClick={() => setPopup("account")}>Financial Accounting</li>
                  <li onClick={() => setPopup("computer")}>Computer Application</li>
                </ul>

                <p><b>Intake:</b> 120</p>
                <p><b>Duration:</b> 3 Years</p>
              </div>

              {/* BSC */}
              <div className="card">
                <h3>Bachelor of Science (B.Sc)</h3>

                <ul>
                  <li onClick={() => setPopup("chemistry")}>Chemistry</li>
                  <li onClick={() => setPopup("zoology")}>Zoology</li>
                  <li onClick={() => setPopup("botany")}>Botany</li>
                </ul>

                <p><b>Intake:</b> 120</p>
                <p><b>Duration:</b> 3 Years</p>
              </div>

            </div>
          </section>
        </>
      )}

      {/*  POPUP  */}
      {popup && (
        <div className="popup">
          <div className="popup-box">
            <button onClick={() => setPopup("")}>X</button>

            {popup === "political" && <p>Study of government systems, politics, and public administration.</p>}
            {popup === "psychology" && <p>Understanding human behavior, emotions, and mental processes.</p>}
            {popup === "sociology" && <p>Study of society, relationships, and social behavior.</p>}

            {popup === "office" && <p>Learn office administration and secretarial practices.</p>}
            {popup === "account" && <p>Study financial records, auditing, and accounting principles.</p>}
            {popup === "computer" && <p>Basics of computer applications and business software.</p>}

            {popup === "chemistry" && <p>Study of chemical substances, reactions, and lab work.</p>}
            {popup === "zoology" && <p>Study of animals, their biology, and ecosystems.</p>}
            {popup === "botany" && <p>Study of plants, structure, and growth.</p>}
          </div>
        </div>
      )}

    </div>
  );
}

export default Programs;